import { Box } from '@mui/material';
import React from 'react';
import { AdminDataTable } from '../../components';
import { getAssessmentColumns } from '../../functions';
import { useAssessmentTab } from '../../hooks';
import type { IAssessmentRow, IAssessmentTabProps } from '../../interfaces';

export const AssessmentTab = ({ searchTerm }: IAssessmentTabProps) => {
  const {
    data,
    loading,
    pageNumber,
    totalPages,
    onPageChange,
    handleRowClick,
    totalRecords,
  } = useAssessmentTab(searchTerm);

  const columns = getAssessmentColumns(handleRowClick);

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <AdminDataTable<IAssessmentRow>
        columns={columns}
        rows={data}
        isLoading={loading}
        currentPage={pageNumber}
        totalPages={totalPages}
        totalRecords={totalRecords}
        rowsPerPage={5}
        onPageChange={onPageChange}
        onRowClick={handleRowClick}
        emptyTitle="No Assessments Available"
        emptySubtitle="There are currently no assessment records matching your criteria."
      />
    </Box>
  );
};
